export const REFERRALS_SUMMARY_REQUEST_START: string = 'referrals/summary/REQUEST_START';
export const REFERRALS_SUMMARY_REQUEST_FAIL: string = 'referrals/summary/REQUEST_FAIL';
export const REFERRALS_SUMMARY_REQUEST_SUCCESS: string = 'referrals/summary/REQUEST_SUCCESS';

export const REFERRALS_MONTHS_DETAILS_REQUEST_START: string = 'referrals/month/details/REQUEST_START';
export const REFERRALS_MONTHS_DETAILS_REQUEST_FAIL: string = 'referrals/month/details/REQUEST_FAIL';
export const REFERRALS_MONTHS_DETAILS_REQUEST_SUCCESS: string = 'referrals/month/details/REQUEST_SUCCESS';

export const REFERRALS_DETAIL_REQUEST_START: string = 'referrals/detail/REQUEST_START';
export const REFERRALS_DETAIL_REQUEST_FAIL: string = 'referrals/detail/REQUEST_FAIL';
export const REFERRALS_DETAIL_REQUEST_SUCCESS: string = 'referrals/detail/REQUEST_SUCCESS';
export const REFERRALS_DETAIL_RESET: string = 'referrals/detail/RESET';

export const REFERRALS_SEARCH_REQUEST_START: string = 'referrals/search/REQUEST_START';
export const REFERRALS_SEARCH_REQUEST_SUCCESS: string = 'referrals/search/REQUEST_SUCCESS';
export const REFERRALS_SEARCH_REQUEST_FAIL: string = 'referrals/search/REQUEST_FAIL';
export const REFERRALS_SEARCH_RESET: string = 'referrals/search/RESET';
